import { onFormCreate } from 'redux/forms/sagas/createFormSaga';
import { onFormDeactivate } from 'redux/forms/sagas/deactivateFormSaga';
import { onFormDelete } from 'redux/forms/sagas/deleteFormSaga';
import { getForms, getApplicationForms, onGetSingleForm } from 'redux/forms/sagas/fetchForms';
import {
  onSearchForms,
  onSearchFormByStatus,
} from 'redux/forms/sagas/searchFormsSaga';
import { call, all } from 'redux-saga/effects';

export default function* formsSaga() {
  yield all([
    call(onFormCreate),
    call(onFormDelete),
    call(getForms),
    call(onGetSingleForm),
    call(getApplicationForms),
    call(onSearchForms),
    call(onSearchFormByStatus),
    call(onFormDeactivate),
  ]);
}
